import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetEmployeeSchedule } from "widgets/src/WidgetEmployeeSchedule/WidgetEmployeeSchedule";
import { WidgetEmployeeSchedulePreviewQuery } from "./__generated__/WidgetEmployeeSchedulePreviewQuery.graphql";

type Props = {
  storecastId: string;
  query: PreloadedQuery<WidgetEmployeeSchedulePreviewQuery>;
};

export const WIDGET_EMPLOYEE_SCHEDULE_PREVIEW_QUERY = graphql`
  query WidgetEmployeeSchedulePreviewQuery(
    $input: PreviewWidgetEmployeeScheduleInput!
    $storecastId: ID!
  ) {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetEmployeeSchedule(input: $input) {
        ...WidgetEmployeeSchedule_widgetEmployeeSchedule
      }
    }
  }
`;
export function WidgetEmployeeSchedulePreview(props: Props) {
  const data = usePreloadedQuery<WidgetEmployeeSchedulePreviewQuery>(
    WIDGET_EMPLOYEE_SCHEDULE_PREVIEW_QUERY,
    props.query
  );

  if (!data.dashboard.previewWidgetEmployeeSchedule) {
    return null;
  }
  return (
    <WidgetEmployeeSchedule
      interactive={false}
      widget={data.dashboard.previewWidgetEmployeeSchedule}
      mode="IDLE"
      storecastId={props.storecastId}
    />
  );
}
